import {ContextMenu} from "./contextMenu";

export class DataTableContextMenu<T> extends ContextMenu<T> {
	/**
	 * Renders the context menu definition.
	 * At this time it will be decided what elements are displayed and what elements are active.
	 * This can be easily plugged into a datatables column definiton by providing this function as a renderer:
	 * {
	 *	data: "id",
	 *  render: dataTableContextMenu.render,
	 *  visible: true,
	 * }
	 */
	public render = (data: unknown, type: string, row: T, meta: DataTables.CellMetaSettings) => {
		const contextMenu = this.renderDropdown(row);

		if (contextMenu !== "") {
			return $("<ul>").addClass("list-icon")
				.append($("<li>").addClass("dropdown")
					.append($("<a>", {"data-toggle": "dropdown", "aria-expanded": "false"}).addClass("dropdown-toggle")
						.append($("<i>").addClass("far fa-bars")))
					.append(contextMenu)
				)
				.prop("outerHTML") as string;
		} else {
			return "";
		}
	}

	/**
	 * Registers click listeners for the context menu on the specified table.
	 */
	public registerOnTable(table: DataTables.Api, allowRightClick: boolean = true) {
		const tableMethods = table.tables();
		const wrapper = $(tableMethods.containers());
		const tbody = tableMethods.body();
		if (tbody) {
			$(tbody)
				.on("click", "ul.dropdown-menu > li", (event) => {
					const element = $(event.currentTarget as HTMLElement);
					if (!element.hasClass("disabled")) {
						const tr = element.closest("tr");
						this.handleClick(table, element, tr);
					}
				})
				.on("shown.bs.dropdown", "div.dropdown", (event) => {
					const element = $(event.target as HTMLElement);
					const menu = element.children("ul.dropdown-menu");
					const tr = element.closest("tr");
					const record = table.row(tr).data() as T;
					this.updateDynamicRecordActiveness(record, menu);
				});
		}

		if (allowRightClick) {
			const containerID = "container_" + crypto.randomUUID();
			const rightClickMenuContainer = $("<div class='context-table-row'>");
			rightClickMenuContainer.attr("id", containerID);
			wrapper.append(rightClickMenuContainer);

			table.on("preDraw", (e, settings) => {
				tbody.$("tr[role=row]")
					.attr("data-toggle", "context")
					.attr("data-target", "#" + containerID);
			});

			rightClickMenuContainer
				.on("show.bs.context", e => {
					if (!this._onOpenByRightClick()) {
						// Block the opening of the context menu
						e.preventDefault();
						return;
					}

					// $element is a bootstrap-context addition absent from the jQuery event typings.
					const contextEvent = e as BootstrapContextEvent;
					const tr = contextEvent.relatedTarget.$element;
					tr.closest("tbody").find(`a[aria-expanded="true"]`).each((i, ele) => {
						$(ele).attr("aria-expanded", "false");
						$(ele).closest("li.dropdown").removeClass("open");
					});
					const recording = table.row(tr).data() as T;
					const contextMenu = this.renderDropdown(recording);
					if (contextMenu !== "") {
						this.updateDynamicRecordActiveness(recording, contextMenu);
					}
					$(e.target).empty().append(contextMenu).data("target-tr", tr);
				})
				.on("hidden.bs.context", (e) => {
					$(e.target).empty();
				})
				.on("click", "ul.dropdown-menu > li", (e) => {
					const element = $(e.currentTarget as HTMLElement);
					if (!element.hasClass("disabled")) {
						const tr = element.closest(".context-table-row").data("target-tr") as JQuery;
						this.handleClick(table, element, tr);
					}
				});
		}
	}

	private handleClick(table: DataTables.Api, element: JQuery, tr: JQuery) {
		const action = element.data("action") as string;
		const recording = table.row(tr).data() as T;
		this.triggerAction(action, recording, tr);
	}
}
